import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import DepartmentEdit from "../components/DepartmentEdit";


const EditDepartment = () => {
  return (
    <>


        {/* Breadcrumb */}
        <div className="d-flex justify-content-between"><h5>Edit Department  </h5><Breadcrumb title="Edit Department" /></div>
        {/* UsersListLayer */}
        <DepartmentEdit />


    </>
  );
};

export default EditDepartment; 